import React from "react"

import Divider from "./divider"

interface Props {
    readonly items: ItemConfig[]
}

export default function ListWithDividers({ items }: Props) {
    const last = items.length - 1

    return (
        <>
            {items.map((item, index) => {
                const {
                    Component,
                    shouldRender = true,
                    shouldHideDivider = false,
                } = item
                if (!Component || !shouldRender) return null

                const isLast = index === last
                const shouldShowDivider = !isLast && !shouldHideDivider

                return (
                    <>
                        {Component}
                        {shouldShowDivider && <Divider />}
                    </>
                )
            })}
        </>
    )
}

type ItemConfig = {
    Component?: React.JSX.Element
    shouldRender?: boolean
    shouldHideDivider?: boolean
}
